module.exports = __webpack_public_path__ + "static/media/music.a5c867fd.jpg";